<template>
  <div class="blog-item">
    <div class="blog-item__image">
      <div
        v-if="imagesLoading"
        class="loading-wraper blog-item__image__container"
      >
        <img
          :src="placeholder"
          class="blog-item__image__default img-placeholder"
          alt="Logo"
        />
        <div class="loading-animation"></div>
      </div>
      <div
        v-else-if="blog.link && blog.image"
        class="blog-item__image__container"
      >
        <a :href="normalizeLink(blog.link)" target="_blank">
          <img
            :src="blog.image"
            class="blog-item__image__default"
            alt="Preview"
          />
        </a>
      </div>
      <div v-else class="blog-item__image__container">
        <a
          v-if="!blog.image && blog.link"
          :href="normalizeLink(blog.link)"
          target="_blank"
        >
          <img
            :src="logo.default"
            :srcset="logo.srcset"
            :sizes="logo.sizes"
            class="blog-item__image__default"
            alt="Logo"
          />
        </a>
        <img
          v-else-if="blog.image && !blog.link"
          :src="blog.image"
          class="blog-item__image__default"
          alt="Logo"
        />
        <img
          v-else
          :src="logo.default"
          :srcset="logo.srcset"
          :sizes="logo.sizes"
          class="blog-item__image__default"
          alt="Logo"
        />
      </div>
      <div class="blog-item__image__container">
        <h3 class="blog-item__title">
          {{ localizedBlogContents.title }}
        </h3>
      </div>
    </div>
    <p class="blog-item__description">
      {{ localizedBlogContents.description }}
    </p>
    <a
      v-if="blog.link"
      target="_blank"
      class="blog-item__link"
      :href="normalizeLink(blog.link)"
      >{{ $t(`message.blogs.link`) }}</a
    >
    <p class="blog-item__keywords">
      {{ localizedBlogContents.keywords }}
    </p>
  </div>
  <div class="blog-item__horizontal-bar"></div>
</template>

<script>
import LogoIizenglishVerticalCouleurPetitFormat from "@/assets/homepage/logo-iizenglish-vertical-couleur-petit-format-1.webp";
import LogoIizenglishVerticalCouleurPetitFormatSmall from "@/assets/homepage/logo-iizenglish-vertical-couleur-petit-format-1-small.webp";
import LogoIizenglishVerticalCouleurPetitFormatMedium from "@/assets/homepage/logo-iizenglish-vertical-couleur-petit-format-1-medium.webp";
import PlaceholderImage from "@/assets/placeholder-image.webp";
export default {
  props: {
    blog: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      logo: {
        default: LogoIizenglishVerticalCouleurPetitFormat,
        srcset: `
          ${LogoIizenglishVerticalCouleurPetitFormatSmall} 125w,
          ${LogoIizenglishVerticalCouleurPetitFormatMedium} 188w,
          ${LogoIizenglishVerticalCouleurPetitFormat} 250w
        `,
        sizes: `
          (max-width: 580px) 125px,
          (max-width: 993px) 188px,
          250px
        `,
      },
      placeholder: PlaceholderImage,
    };
  },
  computed: {
    selectedLocale() {
      return this.$i18n.locale;
    },
    localizedBlogContents() {
      return this.$i18n.locale in this.blog.contents
        ? this.blog.contents[this.$i18n.locale]
        : this.blog.contents[
            this.$store.getters["locales/getDefaultLocale"].code
          ];
    },
    imagesLoading() {
      return this.$store.state.blog.imagesLoading;
    },
  },
  methods: {
    normalizeLink(link) {
      if (!link.startsWith("https://") && !link.startsWith("http://")) {
        return "https://" + link;
      }
      return link;
    },
  },
};
</script>

<style lang="scss" scoped>
.blog-item {
  margin-bottom: 80px;
  &__horizontal-bar {
    border-bottom: 1px solid #6587ce;
    margin-bottom: 80px;
  }
  &__image {
    display: flex;
    align-items: center;
    &__default {
      height: 190px !important;
      box-shadow: none !important;
    }
    img {
      height: 300px;
      box-shadow: 5px 5px 5px 1px rgba(0, 0, 0, 0.2);
    }
    &__container {
      display: flex;
      justify-content: center;
      width: 100%;
    }
  }
  &__description {
    margin-top: 50px;
    white-space: pre-wrap;
  }
  &__title {
    text-align: center;
    font-family:
      Averia Sans Libre,
      sans-serif;
    font-size: 2em;
    color: #6587ce;
    justify-content: center;
    display: flex;
  }
  &__link {
    font-weight: 700;
    margin: 10px 0 15px 0;
    white-space: nowrap;
    color: inherit;
    text-decoration: none;
    cursor: pointer;
    &:hover {
      color: $secondaryColor;
    }
  }
  &__keywords {
    margin-top: 20px;
    text-transform: uppercase;
    font-weight: bold;
    color: #6587ce;
  }
  &__header {
    font-size: 1.5rem;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .loading-wraper {
    position: relative;

    .loading-animation {
      position: absolute;
      left: -45%;
      height: 100%;
      width: 45%;
      background-image: linear-gradient(
        to left,
        rgba(251, 251, 251, 0.05),
        rgba(251, 251, 251, 0.15),
        rgba(251, 251, 251, 0.3),
        rgba(251, 251, 251, 0.15),
        rgba(251, 251, 251, 0.05)
      );
      background-image: -moz-linear-gradient(
        to left,
        rgba(251, 251, 251, 0.05),
        rgba(251, 251, 251, 0.15),
        rgba(251, 251, 251, 0.3),
        rgba(251, 251, 251, 0.15),
        rgba(251, 251, 251, 0.05)
      );
      background-image: -webkit-linear-gradient(
        to left,
        rgba(251, 251, 251, 0.05),
        rgba(251, 251, 251, 0.15),
        rgba(251, 251, 251, 0.3),
        rgba(251, 251, 251, 0.15),
        rgba(251, 251, 251, 0.05)
      );
      animation: loading 1s infinite;
      z-index: 45;
    }
  }

  @keyframes loading {
    0% {
      left: -45%;
    }
    100% {
      left: 100%;
    }
  }
  @media screen and (max-width: 993px) {
    &__title {
      margin-top: 20px;
    }
    &__image {
      flex-direction: column;
    }
  }
  @media screen and (max-width: 580px) {
    &__title {
      font-size: 2em;
    }
    &__image {
      img {
        width: 100% !important;
      }
    }
  }
}
</style>
